/* styles.ts */
import styled from "styled-components";

/**
 * Container principal para o card expandido.
 */
export const ExpandedCardContainer = styled.div`
  gap: ${({ theme }) => theme.spacing(3)};
  transition: all 0.3s ease-in-out;
  flex-direction: column;
  display: flex;
`;
